export const PUBLIC_PATHS = ['/sign-in(.*)', '/sign-up(.*)'];

// Environment variables
export const AUTHENTICATE_AS = import.meta.env.VITE_AUTHENTICATE_AS;
export const APP_ENV = import.meta.env.VITE_APP_ENV;
export const LOGGED_IN_AS_COOKIE = import.meta.env.VITE_LOGGED_IN_AS_COOKIE;
export const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY;
export const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST;
export const INTERCOM_APP_ID = import.meta.env.VITE_INTERCOM_APP_ID;
export const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
